import classnames from "classnames";
import markdown from "markdown-it";
import PropTypes from "prop-types";
import React from "react";

import "./Markdown.scss";

const markdownIt = markdown();

export const Markdown = (props) => {
  const {children, className, inline} = props;

  const innerHTML = {__html: markdownIt.render(children)};
  const rootClassName = classnames("Markdown", className, {
    "Markdown-Inline": inline,
  });

  // eslint-disable-next-line react/no-danger
  return <div className={rootClassName} dangerouslySetInnerHTML={innerHTML} />;
};

Markdown.defaultProps = {
  inline: false,
};
Markdown.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  inline: PropTypes.bool,
};

export default Markdown;



/** WEBPACK FOOTER **
 ** ./src/app/components/shared/Markdown.js
 **/